<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div
        class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
      >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Torneo</label>
                <select
                  v-model="filters.tournamentId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                  @click="getMatchesByTournament()"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsTournament"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Partido</label>
                <select
                  v-model="filters.matchId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsMatch"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Nombre de la Jugada</label>
                <input
                  type="text"
                  v-model="filters.name"
                  class="form-control h-55"
                  placeholder="Ingrese nombre"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Estado Jugada</label>
                <select
                  v-model="filters.playStatusId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsPlayStatus"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Estado Registro</label>
                <select
                  v-model="filters.isActive"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option value="true">{{ STATUS.ACTIVE }}</option>
                  <option value="false">{{ STATUS.INACTIVE }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-7 col-sm-6 text-end mt-4">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                <button
                  type="button"
                  @click.prevent="getPlays(currentPage)"
                  class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                >
                  Buscar
                </button>
                <RouterLink to="/play/create">
                  <button
                    type="button"
                    class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                  >
                    <span class="py-sm-1 d-block">
                      <span>Agregar Jugada</span>
                    </span>
                  </button>
                </RouterLink>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col" class="text-center"></th>
                <th scope="col">#</th>
                <th scope="col" class="text-center">Torneo</th>
                <th scope="col" class="text-center">Partido</th>
                <th scope="col" class="text-center">Jugada</th>
                <th scope="col" class="text-center">Fecha Inicio</th>
                <th scope="col" class="text-center">Fecha Fin</th>
                <th scope="col" class="text-center">Orden</th>
                <th scope="col" class="text-center">Estado Partido</th>
                <th scope="col" class="text-center">Estado Registro</th>
                <th scope="col" class="text-center">
                  Creado<br />
                  por
                </th>
                <th scope="col" class="text-center">Fecha <br />creación</th>
                <th scope="col" class="text-center">Modificado <br />por</th>
                <th scope="col" class="text-center">
                  Fecha <br />
                  modificación
                </th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <draggable
              v-if="items.length"
              v-model="items"
              item-key="id"
              tag="tbody"
              handle=".drag-handle"
              :animation="200"
              :disabled="!enableOrder"
              @end="updateOrderItems"
            >
              <template #item="{ element: item, index }">
                <tr>
                  <td
                    class="text-body text-right drag-handle"
                    :class="{ 'opacity-50': !enableOrder }"
                  >
                    <i
                      class="material-symbols-outlined fs-16 text-primary"
                      :class="
                        enableOrder ? 'cursor-move' : 'cursor-not-allowed'
                      "
                    >
                      drag_indicator
                    </i>
                  </td>
                  <td>
                    {{ index + 1 + (currentPage - 1) * pageSize }}
                  </td>
                  <td class="text-body">{{ item.match.tournament.name }}</td>
                  <td class="text-body">{{ item.match.name }}</td>
                  <td>{{ item.name }}</td>
                  <td class="text-body">{{ item.startDateTimeString }}</td>
                  <td class="text-body">{{ item.endDateTimeString }}</td>
                  <td class="text-body">{{ item.order }}</td>
                  <td class="text-body text-center">
                    {{ item.playStatus.name }}
                  </td>
                  <td class="text-body text-center">
                    <span
                      @click="confirmChangeStatus(item.id, item.isActive)"
                      class="badge bg-opacity-10 p-2 fs-12 fw-normal"
                      role="button"
                      :class="computeStatusClass(item.isActive)"
                    >
                      {{ item.isActive ? STATUS.ACTIVE : STATUS.INACTIVE }}
                    </span>
                  </td>
                  <td class="text-body">{{ item.createdBy }}</td>
                  <td class="text-body">{{ item.createdAtDateTimeString }}</td>
                  <td class="text-body">{{ item.updatedBy }}</td>
                  <td class="text-body">{{ item.updatedAtDateTimeString }}</td>
                  <td class="text-center">
                    <div class="">
                      <RouterLink :to="`/play/edit/${item.id}`">
                        <i class="material-symbols-outlined fs-16 text-primary">
                          edit
                        </i>
                      </RouterLink>
                      <RouterLink :to="`/play/config/${item.id}`">
                        <i
                          class="material-symbols-outlined fs-16 text-primary ps-2"
                        >
                          settings
                        </i>
                      </RouterLink>
                    </div>
                  </td>
                </tr>
              </template>
            </draggable>
          </table>
        </div>

        <div class="p-4 pt-lg-4">
          <Pagination
            :currentPage="currentPage"
            :pageSize="pageSize"
            :totalItems="totalItems"
            @update:page="fetchPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";
import api from "@/services/api";
import { PAGINATION_ITEMS_PER_PAGE, STATUS, LABELS } from "@/utils/constants";
import draggable from "vuedraggable";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Plays",
  components: {
    Pagination,
    OverlayLoader,
    draggable,
  },
  setup() {
    const isLoading = ref(false);
    const enableOrder = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const toast = useToast();

    const itemsPlayStatus = ref<any[]>([]);
    const itemsTournament = ref<any[]>([]);
    const itemsMatch = ref<any[]>([]);
    const items = ref<any[]>([]);

    const filters = ref({
      name: "",
      tournamentId: null,
      matchId: null,
      playStatusId: null,
      isActive: null,
    });

    const computeStatusClass = (classValue: boolean) => {
      return {
        shipped: classValue,
        deactive: !classValue,
      };
    };

    onMounted(async () => {
      await getPlayStatus();
      await getTournaments();
      await getPlays(currentPage.value);
    });

    const getPlayStatus = async () => {
      try {
        const response = await api.get(`/common/playStatus`);
        itemsPlayStatus.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    const getTournaments = async () => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;

        const response = await api.get(`/tournament?${params}`);

        itemsTournament.value = response.data.list;
      } catch (error) {
        console.error(error);
      }
    };

    const getMatchesByTournament = async () => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;

        if (filters.value.tournamentId) {
          params = params + `&tournamentId=${filters.value.tournamentId}`;
        }

        const response = await api.get(`/match?${params}`);

        itemsMatch.value = response.data.list;
      } catch (error) {
        console.error(error);
      }
    };

    const getPlays = async (page: number) => {
      try {
        isLoading.value = true;
        var params = `pageNumber=${page}&pageSize=${pageSize.value}`;
        if (filters.value.name) {
          params = params + `&name=${filters.value.name}`;
        }
        if (filters.value.tournamentId) {
          params = params + `&tournamentId=${filters.value.tournamentId}`;
        }
        if (filters.value.matchId) {
          params = params + `&matchId=${filters.value.matchId}`;
        }
        if (filters.value.playStatusId) {
          params = params + `&playStatusId=${filters.value.playStatusId}`;
        }
        if (filters.value.isActive) {
          params = params + `&isActive=${filters.value.isActive}`;
        }

        const response = await api.get(`/play?${params}`);

        items.value = response.data.list;
        totalItems.value = response.data.rows;

        enableOrder.value =
          filters.value.tournamentId != null &&
          filters.value.matchId != null &&
          !filters.value.name &&
          filters.value.playStatusId == null &&
          filters.value.isActive == null;
      } catch (error) {
        console.error(error);
        enableOrder.value = false;
      } finally {
        isLoading.value = false;
      }
    };

    const fetchPage = async (page: number) => {
      currentPage.value = page;
      getPlays(currentPage.value);
    };

    const confirmChangeStatus = async (id: number, status: boolean) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>${
          status ? "desactivar" : "activar"
        }</b> la Jugada?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí, ${status ? "desactivar" : "activar"} `,
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        isLoading.value = true;

        var obj = {
          id: id,
          status: !status,
        };

        const response: any = await api.put(`/play`, obj);

        if (response != 0) {
          toast.success(
            `La Jugada fue ${status ? "desactivada" : "activada"} con éxito.`,
            {
              timeout: 2000,
            }
          );
          fetchPage(currentPage.value);
        } else {
          toast.error(
            `La Jugada no pudo ser ${status ? "desactivada" : "activada"}.`,
            {
              timeout: 2000,
            }
          );
        }
        isLoading.value = false;
      }
    };
    const updateOrderItems = async () => {
      items.value.forEach((item, index) => {
        item.order = index + 1;
      });

      isLoading.value = true;

      try {
        const response: any = await api.put(
          `/play/play-update-order`,
          items.value
        );
        isLoading.value = false;

        if (response.data) {
          toast.success(`Se actualizó el orden de las jugadas.`, {
            timeout: 3000,
          });
        }
      } catch (ex) {
        toast.error("El orden de las jugadas no pudo ser actualizado.", {
          timeout: 2000,
        });
        console.error(ex);
        isLoading.value = false;
      }
    };
    return {
      items,
      itemsPlayStatus,
      itemsTournament,
      itemsMatch,
      currentPage,
      pageSize,
      totalItems,
      STATUS,
      LABELS,
      OverlayLoader,
      filters,
      isLoading,
      computeStatusClass,
      getMatchesByTournament,
      getPlays,
      fetchPage,
      confirmChangeStatus,
      enableOrder,
      updateOrderItems,
    };
  },
});
</script>
